import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import SelectField from '@wix/da-ds/pkg/Dropdown/select/SelectField/SelectField';
import { DiscountFormField } from '../../../types';

interface Props {
  className?: string;
}

const AudienceSelector: FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const { control, errors, watch } = useFormContext();
  const appliesToCategory = watch(DiscountFormField.AppliesToCategory);

  const options = [
    {
      label: t('studio.discountModal.form.audienceInput.option.all'),
      value: 'all',
    },
    {
      label: t('studio.discountModal.form.audienceInput.option.watchers'),
      value: 'watchers',
    },
    {
      label: t('studio.discountModal.form.audienceInput.option.supporters'),
      value: 'supporters',
    },
  ];
  if (appliesToCategory === 'shop_products') {
    options.push({
      label: t('studio.discountModal.form.audienceInput.option.subscribers'),
      value: 'subscribers',
    });
  }

  return (
    <Controller
      name={DiscountFormField.Audience}
      control={control}
      render={({ onChange, value, name }) => {
        const error = errors[name];
        return (
          <SelectField
            id={DiscountFormField.Audience}
            className={className}
            name={DiscountFormField.Audience}
            label={t('studio.discountModal.form.audienceInput.label')}
            value={value}
            isRequired
            noBottomSpacing={false}
            error={error?.message}
            onChange={onChange}
            items={options}
          />
        );
      }}
    />
  );
};
AudienceSelector.displayName = 'AudienceSelector';

export default AudienceSelector;
